import React from 'react';
import { Card, Skeleton, SkeletonLine, SkeletonBlock } from '@one-thd/sui-atomic-components';

const RentalsServicesSkeleton = () => {
  return (
    <div className="sui-flex sui-flex-col sui-gap-4">
      <SkeletonLine variant="heading" />
      <div className="sui-grid sui-grid-cols-1 md:sui-grid-cols-2 lg:sui-grid-cols-3 sui-gap-8">
        {Array(3).fill('').map((__, index) => (
          <Card key={index} className="sui-w-full" disablePadding>
            <Skeleton grow key={index}>
              <SkeletonBlock aspect="square" />
              <SkeletonLine variant="heading" />
              <SkeletonLine variant="multi" numberOfLines={2} />
            </Skeleton>
          </Card>
        ))}
      </div>
    </div>
  );
};

export default RentalsServicesSkeleton;